module.exports = {"unsupportedBrowser":"지원하지 않는 브라우저 입니다.","checkIdPw":"아이디와 비밀번호를 확인해주세요.","greenTempFileName":"기간별 그린 온도"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/routermsg.json
// module id = Il2T
// module chunks = 2